// sekcja z metodami płatności - lokalny override
// @ts-nocheck

import React, { FC } from 'react';
import classnames from 'classnames';

import { useGetCartPaymentsMethods } from 'api';
import { ICartMainData, ICartMainDataUpdateRequest } from 'api/types';

import styles from 'theme/pages/Checkout/components/Payment/Payment.module.scss';

// typ danych wejściowych
interface IProps {
  cartId: number;
  paymentMethod: ICartMainData['payment_method'];
  updateCartMainData: (data: Partial<ICartMainDataUpdateRequest>) => void;
}

const Payment: FC<IProps> = ({ cartId, paymentMethod, updateCartMainData }) => {
  // pobranie listy metod płatności
  const { data: cartPaymentsMethodsData } = useGetCartPaymentsMethods(cartId, {
    page: 1,
    limit: 999
  });

  // Wyświetl tylko wybraną metodę płatności
  const selectedPaymentMethod = paymentMethod?.id
    ? cartPaymentsMethodsData?.items.find((item) => item.id === paymentMethod.id)
    : null;

  // Jeśli nie ma wybranej metody, wyświetl pierwszą dostępną (jeśli istnieje)
  const displayMethod = selectedPaymentMethod || cartPaymentsMethodsData?.items?.[0];

  if (!displayMethod) {
    return null;
  }

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Pages-Checkout-Components-Payment'
      )}>
      <div className={styles.paymentMethodWrapper}>
        {displayMethod.limit_comment && (
          <div className={styles.limitComment}>
            {displayMethod.limit_comment}
          </div>
        )}
        <div className={classnames(styles.item, styles.active)}>
          <div className={styles.content}>
            <div className={styles.iconWrapper}>
              <img className={styles.icon} src={displayMethod.image} alt="icon" />
            </div>
            <div className={styles.name}>{displayMethod.name}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payment;

